import { BaseModel } from "../../../shared/base/base.models";

export class DocumentNumber extends BaseModel {
    documentType?: string;
    usesYear?: boolean;
    prefix?: string = '';
}
